import {PARAM_CHANGE} from '@store/actions';
import BLOCKS from '@store/blocks';

import utils from '@utils';

export function ZOOM(store, val) {
  const offset = store.get(BLOCKS.MAP.OFFSET);
  const zoom = store.get(BLOCKS.MINI_MAP.ZOOM);
  const delta = 0.5;
  let rightBounds = utils.snapToBounds(
    offset.x + delta / zoom - delta / val,
    offset.y + delta / zoom - delta / val,
    1 / val,
    1 / val);

  PARAM_CHANGE(store, BLOCKS.MAP.OFFSET, rightBounds);
  PARAM_CHANGE(store, BLOCKS.MINI_MAP.ZOOM, val);
}

export function GLIDE(store, val) {
  const zoom = store.get(BLOCKS.MINI_MAP.ZOOM);
  let rightBounds = utils.snapToBounds(val.x, val.y, 1 / zoom, 1 / zoom);

  PARAM_CHANGE(store, BLOCKS.MAP.OFFSET, rightBounds);
}